/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useContext, useState } from "react";
import { tokens } from "../../theme";
import { UserContext } from "../../contexts";
import {
  Box,
  Grid,
  MenuItem,
  Switch,
  Stack,
  Tab,
  Typography,
  useTheme,
} from "@mui/material";
import Select from "../../components/SearchableSelect";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Sync } from "@mui/icons-material";
import CPRequests from "./CPRequests";
import Header from "../../components/Header";
import DataGridButton from "../../components/DataGridButton";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import { toPascalCase, toTitleCase } from "../../utils/helperFunctions";
import { REQUEST_STATUS, REQUEST_VIEWS } from "../../utils/constants";
import styles from "./styles";
import { dataGridButtonTypography } from "../../styles/DataGridStyles";
import { dataGridButtonStyles } from "../../styles/buttonStyles";

const Requests = () => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  const loggedInUser = useContext(UserContext);

  const [selectedTab, setSelectedTab] = useState("Control Plane");
  const [selectedView, setSelectedView] = useState(
    loggedInUser?.data?.quotas?.controlPlane?.allocated
      ? REQUEST_VIEWS.requestsReceived
      : REQUEST_VIEWS.requestsMade
  );
  const [refreshToggle, setRefreshToggle] = useState(false);
  const [requestFilter, setRequestFilter] = useState({ PENDING: true });

  const [confirmationDialog, setConfirmationDialog] = useState({
    isOpen: false,
    content: "",
    handleDialogConfirm: () => {},
  });

  const resetDialog = () => {
    setConfirmationDialog({
      isOpen: false,
      content: "",
      handleDialogConfirm: () => {},
    });
  };

  const tabContentComponentProps = {
    view: selectedView,
    setConfirmationDialog: setConfirmationDialog,
    requestFilter: requestFilter,
    refreshToggle: refreshToggle,
    setRefreshToggle: setRefreshToggle,
  };
  const tabs = [
    {
      value: "Control Plane",
      component: <CPRequests {...tabContentComponentProps} />,
    },
  ];

  return (
    <Box sx={styles.mainBox}>
      <ConfirmationDialog
        isOpen={confirmationDialog.isOpen}
        handleDialogConfirm={confirmationDialog.handleDialogConfirm}
        content={confirmationDialog.content}
        resetDialog={resetDialog}
      />
      <Grid sx={styles.gridContainer} container columns={2}>
        <Grid item xs={1}>
          <Header
            title="Requests"
            subtitle="Manage the requests pending for approval"
          />
        </Grid>
        <Grid item xs={1}>
          <Stack direction="row-reverse" spacing={1} alignItems="center">
            <DataGridButton
              sx={dataGridButtonStyles.pageTopButtons}
              onClick={() => {
                setRefreshToggle((prev) => !prev);
              }}
            >
              <Sync sx={{ fontSize: 16, color: "#fff" }} />
              <Typography sx={dataGridButtonTypography(colors, 500)}>
                RELOAD
              </Typography>
            </DataGridButton>
            <Select
              labelId="select-view-label"
              id="select-view"
              value={selectedView}
              sx={styles.viewSelectSelect}
              onChange={(e) => setSelectedView(e.target.value)}
            >
              {Object.keys(REQUEST_VIEWS).map((view, i) => (
                <MenuItem value={REQUEST_VIEWS[view]} key={i}>
                  {toTitleCase(REQUEST_VIEWS[view])}
                </MenuItem>
              ))}
            </Select>
            {Object.keys(REQUEST_STATUS).map((item, i) => (
              <Fragment key={i}>
                <Box sx={styles.filterText}>{toPascalCase(item)}</Box>
                <Switch
                  checked={requestFilter?.[item]}
                  onChange={() =>
                    setRequestFilter((prev) => ({
                      ...prev,
                      [item]: !(prev?.[item] || false),
                    }))
                  }
                ></Switch>
              </Fragment>
            ))}
          </Stack>
        </Grid>
      </Grid>

      <TabContext value={selectedTab}>
        <Box sx={styles.tabList}>
          <TabList
            onChange={(e, newValue) => {
              setSelectedTab(newValue);
            }}
          >
            {tabs.map((tab, i) => (
              <Tab
                label={tab.value}
                value={tab.value}
                icon={<></>}
                iconPosition="end"
                sx={styles.tabStyle}
                key={i}
              />
            ))}
          </TabList>
        </Box>
        {tabs.map((tab, i) => (
          <TabPanel value={tab.value} key={i}>
            {tab.component}
          </TabPanel>
        ))}
      </TabContext>
      <Box sx={styles.dataGridBoxStyles(colors)}></Box>
    </Box>
  );
};

export default Requests;
